import React from "react";

import { Container, Avatar, Stack, Link, Typography, Divider } from "@mui/material";
/* import { LinkedIn, MailRounded, Telegram } from "@mui/icons-material"; */

export default function Footer() {
  return (
    <Container disableGutters component="footer" maxWidth="none">

      <Container disableGutters maxWidth="lg" sx={{pb:1}}>
        <Divider />
      </Container>

      <Stack direction="row" spacing={3} display="flex" justifyContent="center" sx={{ pt: 3, pb: 3 }}>
        <Link href="https://gitlab.com/users/gustavocx/projects" target="_blank" rel="noreferrer" className="jello-horizontal">
          <Avatar alt="Gitlab" title="Gitlab" src="https://firebasestorage.googleapis.com/v0/b/gustavocx.appspot.com/o/contact%2Fgitlab.svg?alt=media&token=4eda5644-0767-40a3-af17-dc33afbcd559" className="contactImg" sx={{ width: 56, height: 56 }} href="https://google.com" />
        </Link>

        <Link href="mailto:gustavocabezasx@gmail.com" target="_blank" rel="noreferrer" className="jello-horizontal">
          <Avatar alt="Gmail" title="Gmail: gustavocabezasx@gmail.com" src="https://firebasestorage.googleapis.com/v0/b/gustavocx.appspot.com/o/contact%2Fgmail.svg?alt=media&token=e54023cd-9c5e-4947-a612-133c4b8bd705" className="contactImg" sx={{ width: 56, height: 56 }} />
        </Link>

        <Link href="https://linkedin.com/in/gustavocx/" target="_blank" rel="noreferrer" className="jello-horizontal">
          <Avatar alt="Linkedin" title="Linkedin" src={"https://firebasestorage.googleapis.com/v0/b/gustavocx.appspot.com/o/contact%2Flinkedin.svg?alt=media&token=e64e9d08-0689-4d77-b6ca-8e13aa757c1a"} className="contactImg" sx={{ width: 56, height: 56 }} />
        </Link>
      </Stack>

      <Typography variant="body2" align="center" sx={{ pb: 3 }}>
        {"Copyright © " + new Date().getFullYear() + " "}
        <Link color="inherit" href="/" underline="none">
          gustavocx
        </Link>
      </Typography>
    </Container>
  );
}
